<template>
  <div :class="['dialog-wrap', className]">
    <div class="dialog-header">
      <div class="dialog-title">
        <slot name="title"></slot>
      </div>
      <span v-if="showClose" class="dialog-close" @click="handleClose">
        <Icon name="close" size="xs" />
      </span>
    </div>
    <div class="dialog-content">
      <slot></slot>
    </div>
    <div class="dialog-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@/components/basic-components/icon';

interface Props {
  // 自定义类名，应用在最外层元素
  className?: string;
  showClose?: boolean;
}

withDefaults(defineProps<Props>(), {
  className: '',
  showClose: true
});

const emit = defineEmits<{
  close: [];
}>();

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.dialog-wrap {
  background: #ffffff;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 30px 24px;
}

.dialog-title {
  flex: 1;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: #212429;
}

.dialog-close {
  font-size: 24px;
  line-height: 1;
  color: #8c8c8c;
  cursor: pointer;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #262626;
  }
}

.dialog-content {
  padding: 0 30px;
  flex: 1;
  overflow-y: auto;
}

.dialog-footer {
  padding: 24px 30px 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
